import type {Evaluator} from "@cm/graph-v3"
import type {OnCompileContext, OnFilterActiveContext, TemplateNodeContext, TemplateNodeDefinition, VisitorNodeResult} from "#template/template-node/types"
import {skipped} from "#template/template-node/constants"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {TemplateGraphNode} from "#template/nodes/template-graph/template-graph-node"
import {TemplateNodes} from "#template/nodes/template-nodes"
import type {NodeOwnerLikeNode} from "#template/role-markers"
import {nodeOwnerMarker} from "#template/role-markers"
import type {TemplateData} from "#template/compile-context"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import {visitAll} from "#template/template-node/visit-helpers"

export type TemplateGraphParameters = {
    name: string
    nodes: TemplateNodes
}

const templateGraphDefinition: TemplateNodeDefinition<TemplateGraphParameters> = {
    nodeClass: "TemplateGraph",
    validation: {
        parameters: z.object({name: z.string(), nodes: graphNode(TemplateNodes)}),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class TemplateGraph extends TemplateGraphNode<TemplateGraphParameters> implements NodeOwnerLikeNode {
    get [nodeOwnerMarker]() {
        return true as const
    }

    public override get definition() {
        return templateGraphDefinition
    }

    public override onFilterActive(context: OnFilterActiveContext, evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<TemplateGraphParameters> {
        if (this !== context.root) return skipped
        return visitAll(this.parameters, evaluator)
    }

    public override onCompile(_context: OnCompileContext, evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<TemplateGraphParameters> {
        return visitAll(this.parameters, evaluator)
    }

    override evaluate(_scope: GraphBuilderScope, _evaluator: NodeEvaluator): BuilderInlet<TemplateData | null> {
        return {graph: this}
    }
}
